/**
 * @file 보관 채널 읽기 전용 상태 — 채널 화면 전체가 공유하는 단일 출처.
 *
 * <p><b>왜 Context 인가.</b> 쓰기 버튼은 피드 탭 안쪽 깊은 곳에 흩어져 있다
 * (FeedTab → FeedItem → CommentItem → 그 안의 ⋮ 메뉴). prop 으로 내려보내려면 중간 컴포넌트
 * 여덟 개가 자기는 쓰지도 않는 값을 받아 넘겨야 하고, 한 군데만 빠뜨려도 <b>그 버튼만 조용히
 * 살아남는다</b> — 눌러야만 드러나는 종류의 누락이다. Context 는 중간 단계를 건너뛰므로
 * 새 쓰기 UI 를 추가할 때도 훅 한 줄이면 된다.
 *
 * <p><b>이건 화면 처리일 뿐 강제가 아니다.</b> 실제 차단은 서버의
 * {@code ChannelService.assertWritable} 이 한다. 여기서 감추는 이유는 사용자가 누를 수 있는 것을
 * 눌렀다가 오류를 받는 일이 없게 하려는 것 — 두 겹 중 어느 쪽도 다른 쪽을 대신하지 않는다.
 */

import { createContext, useContext } from "react";

const ChannelReadOnlyContext = createContext(false);

/** 채널 화면 루트에서 {@code value={보관여부}} 로 감싼다. */
export const ChannelReadOnlyProvider = ChannelReadOnlyContext.Provider;

/**
 * 이 채널이 읽기 전용(보관됨)인지.
 *
 * <p>쓰기 UI 는 감추는 것을 기본으로 한다 — 비활성 상태로 남겨 두면 "왜 안 눌리는지" 를
 * 툴팁으로 설명해야 하는데, 그 답은 이미 상단 배너가 하고 있다.
 */
export function useChannelReadOnly() {
    return useContext(ChannelReadOnlyContext);
}
